module.exports = __webpack_public_path__ + "static/Danang-2ca6364748e06e75730f2d2bc9a0a331.png";